var processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("./search/search"));
    processInclude(require("coremh/components/contentPlusCarousel"));
    processInclude(require("coremh/components/plpBanner"));
});
